import { render, staticRenderFns } from "./RecordScroll.vue?vue&type=template&id=249739d6&scoped=true&"
import script from "./RecordScroll.vue?vue&type=script&lang=js&"
export * from "./RecordScroll.vue?vue&type=script&lang=js&"
import style0 from "./RecordScroll.vue?vue&type=style&index=0&id=249739d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249739d6",
  null
  
)

export default component.exports